export const SDK_NAME = "yxt-sentry-uniapp";
export const SDK_VERSION = "1.1.3";
